module.exports = __webpack_public_path__ + "static/media/10S.b208cd7f.png";